import React, { useState } from 'react';
import { submissionURL } from '../graphic';

import {
  Checkbox,
  Button,
  Grid,
  FormControl,
  FormHelperText,
  FormControlLabel,
  IconButton,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close';

function Form(props) {
  const { classes } = props;

  const [submission, setSubmission] = useState({
    story: '',
    name: '',
    contact: '',
  });

  const [userAgrees, setUserAgreement] = useState(false);
  const [resError, setResError] = useState(false);
  const [open, setOpen] = useState(false);
  const [submitted, storySubmitted] = useState(false);

  function handleChange(event) {
    const { target } = event;
    const { id, value } = target;

    setSubmission({
      ...submission,
      [id]: value,
    });
  }

  function handleAgreement(event) {
    setUserAgreement(!userAgrees);
  }

  function handleSubmit() {
    storySubmitted(true);

    fetch(submissionURL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submission),
    })
    .then((res) => {
    // successful submission
      setOpen(true);
      storySubmitted(true);
    })
    .catch((err) => {
    // unsuccessful submission
      setOpen(true);
      setResError(true);
    });
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <form className={classes.form}>
      <Grid className={classes.root} container spacing={2}>
        <Grid item xs={12}>
          <TextField
            multiline
            id='story'
            fullWidth={true}
            rows={5}
            variant='outlined'
            label='Share your story'
            value={submission.story}
            onChange={handleChange}
            // placeholder='Required'
            className={classes.textField}
            InputLabelProps={{
              classes: {
                root: classes.outlinedInput,
                shrink: classes.shrunkInput,
                // hello: 'hello'
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='name'
            fullWidth={true}
            // rows={10}
            // variant='outlined'
            label='What is your name and location?'
            value={submission.name}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                shrink: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id='contact'
            placeholder='Email and phone number'
            fullWidth={true}
            label='How can we get in touch?'
            value={submission.contact}
            onChange={handleChange}
            className={classes.textField}
            InputLabelProps={{
              classes: {
                animated: classes.animatedInput,
                root: classes.rootInput,
                focused: classes.focusedInput,
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.disclaimer} variant='subtitle2'>
            By submitting your story, including your name, and any other personal information (“Story”) you agree that
            your Story may be used, published and distributed by CNN, its affiliates and licensees worldwide on all media
            and platforms for editorial purposes without any limitation in time in accordance with <a href='https://www.cnn.com/2014/01/17/cnn-info/interactive-legal/index.html' target='_blank'>CNN’s terms of service</a>.
            You also agree that we may use any personal contact information you provide to contact you about your Story
            and that we will use such personal contact information in accordance with our privacy policy located
            at <a href='cnn.com/privacy' target='_blank'>cnn.com/privacy</a>.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            paddingTop: 0,
            paddingBottom: 0,
          }}>
          <FormControl
            // required
            error={!userAgrees}
            disabled={submitted}
            component="fieldset" >
              <FormControlLabel
              control={
                <Checkbox
                  checked={userAgrees}
                  onChange={handleAgreement}
                  value="agree"
                  color="primary"
                />
              }
              label="I agree"
            />
          </FormControl>
        </Grid>
        <Grid style={{
          paddingBottom: 0,
        }} item xs={12}>
          <Button
            disabled={!userAgrees || !submission.story.length || submitted}
            className={classes.button}
            variant='contained'
            color="primary"
            size='medium'
            onClick={handleSubmit}>
            {submitted ? 'Submitted' : 'Submit'}
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        className={classes.snackbarContent}
        ContentProps={{
          className: classes.snackbarContent,
        }}
        autoHideDuration={6000}
        onClose={handleClose}
        ContentProps={{
          'aria-describedby': 'message-id',
        }}
        message={
          resError
            ? <span id='message-id'>There was an error.<br/>Please try submitting again</span>
            : <span id="message-id"><strong>Thank you!</strong><br/>Your story has been submitted</span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            className={classes.close}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </form>
  );
}

export default Form;
